import { object, string } from 'yup';

const loginSchema = object({
    username: string().required().min(1, 'Provide a username'),
    password: string().required().min(1, 'Provide a password'),
});

export { loginSchema };
